export default __webpack_public_path__ + "static/product2-4c9ce30530cb433123434f26d4abe2bf.jpg";